import {
  gql,
  QueryHookOptions,
  useApolloClient,
  useQuery,
} from '@apollo/client';
import type {
  GetPageCategoriesQuery,
  GetPageCategoriesQueryVariables,
  GetPageCategoryHistoryQuery,
  GetPageCategoryHistoryQueryVariables,
} from '../../../../__generated__/queries-web';
import { PAGE_CATEGORY_FRAGMENT } from '../fragments/category.web.graphql';

/// GET CATEGORIES ////////////////////////////////////////////
const GET_PAGE_CATEGORIES = gql`
  query GetPageCategories($first: UnsignedInt!, $where: CategoryFilterInput!) {
    categories(first: $first, where: $where, orderBy: title_ASC) {
      ...Category
      children(first: $first, where: $where, orderBy: title_ASC) {
        ...Category
        children(first: $first) {
          ...Category
          children(first: $first) {
            ...Category
            children(first: $first) {
              ...Category
            }
          }
        }
      }
    }
  }
  ${PAGE_CATEGORY_FRAGMENT}
`;

export const useSearchPageCategories = () => {
  const client = useApolloClient();

  return (variables: GetPageCategoriesQueryVariables) =>
    client.query<GetPageCategoriesQuery, GetPageCategoriesQueryVariables>({
      query: GET_PAGE_CATEGORIES,
      variables,
    });
};

export const usePageCategories = <
  T extends GetPageCategoriesQuery,
  K extends GetPageCategoriesQueryVariables
>(
  options: QueryHookOptions<T, K>,
) => useQuery<T, K>(GET_PAGE_CATEGORIES, options);

/// CATEGORY HISTORY ////////////////////////////////////////////
const GET_PAGE_CATEGORY_HISTORY = gql`
  query GetPageCategoryHistory(
    $where: CategoryHistoryFilterInput
    $orderBy: [CategoryHistoryOrderingInput!]
  ) {
    categoryHistories(where: $where, orderBy: $orderBy, first: 999) {
      category {
        ...Category
      }
      createdAt
      id
      user {
        ... on OneUser {
          id
          name
          avatarUrl
        }
      }
    }
  }
  ${PAGE_CATEGORY_FRAGMENT}
`;

export const usePageCategoryHistory = () => {
  const client = useApolloClient();

  return (variables: GetPageCategoryHistoryQueryVariables) =>
    client.query<
      GetPageCategoryHistoryQuery,
      GetPageCategoryHistoryQueryVariables
    >({
      query: GET_PAGE_CATEGORY_HISTORY,
      variables,
    });
};
